import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
}

export function LogoMark({ className }: LogoMarkProps) {
    return (
        <svg
            viewBox='0 0 32 32'
            aria-hidden='true'
            className={cn('size-9 shrink-0', className)}
        >
            <rect width='32' height='32' rx='9' fill='#172B4D' />
            <path d='M8.5 24h15' stroke='#FFFFFF' strokeOpacity='0.28' strokeWidth='2' strokeLinecap='round' />
            <path
                d='M8.5 19.5 12.75 15l3.5 2.75L23.5 10'
                fill='none'
                stroke='#F1B94B'
                strokeWidth='2.6'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <circle cx='23.5' cy='10' r='2.1' fill='#FFFFFF' />
        </svg>
    )
}

interface LogoProps {
    className?: string
    compact?: boolean
    hideTextClassName?: string
}

export default function Logo({ className, compact = false, hideTextClassName }: LogoProps) {
    return (
        <span className={cn('flex min-w-0 items-center gap-2.5', className)}>
            <LogoMark />

            <span className={cn('flex min-w-0 flex-col leading-none', hideTextClassName)}>
                <span className='truncate font-heading text-[0.95rem] font-bold tracking-tight text-navy'>
                    Daily Financial
                </span>

                {!compact && (
                    <span className='mt-1 truncate text-[0.625rem] font-semibold tracking-[0.14em] text-muted-foreground uppercase'>
                        Recording System
                    </span>
                )}
            </span>
        </span>
    )
}
